import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "table table-striped" }
const _hoisted_3 = { class: "w-50" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "99" }
const _hoisted_6 = { class: "w-50" }
const _hoisted_7 = {
  key: 1,
  class: "total"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_localized_text, {
      type: "h5",
      localizedKey: "Materials",
      text: "Materials"
    }),
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Material",
              text: "Material"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Percentage",
              text: "Percentage"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "CO2e per GRAM",
              text: "CO2e per GRAM"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Fabric Grams",
              text: "Fabric Grams"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "CO2e Grams",
              text: "CO2e Grams"
            })
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.item.fabricCompositions.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No Elements Found",
                  text: "No Elements Found"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.fabricCompositions, (material, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(material.rawMaterial.text), 1),
            _createElementVNode("td", null, _toDisplayString(material.percentage) + "%", 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(material.cO2PerGrams)), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(material.totalGrams)), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(material.totalCO2)), 1)
          ]))
        }), 128)),
        (_ctx.item.fabricCompositions.length > 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Total",
                    text: "Total"
                  })
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("percentage", _ctx.item.fabricCompositions))) + "% ", 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("cO2PerGrams", _ctx.item.fabricCompositions))), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("totalGrams", _ctx.item.fabricCompositions))), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("totalCO2", _ctx.item.fabricCompositions))), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}